import React, {useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

import {Select, SelectOption} from 'components/ui-kit/Select';
import {LocaleNames} from 'core/localization';

export const LanguageLabel = styled.div`
    display: flex;
    align-items: center;

    > :first-child {
        margin-right: 8px;
    }
`;

export const CustomSelect = styled(Select)`
    width: 96px;
    margin-right: 15px;
    position: relative;
    z-index: 9;
    .react-select {
        &__value-container {
            padding-right: 0;
        }

        &__dropdown-indicator {
            padding-left: 0;
        }

        &__control {
            padding-right: 5px;
            padding-left: 15px;
            border: 0;
            background: transparent;
        }
    }
`;

type Props = {
    className?: string;
};

export function LanguageSelector({className}: Props) {
    const {i18n} = useTranslation();

    const handleChange = (value: {label?: string; value: string}) => {
        i18n.changeLanguage(value.value);
        localStorage.lang = value.value;
        document.dir = i18n.dir();
    };

    const languageOptions: Array<SelectOption<string>> = Object.entries(LocaleNames).map(
        ([value, {name}]) => ({
            value,
            label: (
                <LanguageLabel>
                    <span>{name}</span>
                </LanguageLabel>
            ),
        }),
    );

    let selectedLanguage: SelectOption<string> | undefined = languageOptions.find(
        (elem) => elem.value === i18n.language,
    );
    useEffect(() => {
        selectedLanguage = languageOptions.find((elem) => elem.value === i18n.language);
        if (!selectedLanguage) handleChange({value: 'en'});
    }, [i18n.language]);

    return (
        <CustomSelect
            isSearchable={false}
            blurInputOnSelect={false}
            options={languageOptions}
            type="text"
            value={selectedLanguage}
            onChange={handleChange}
            className={className}
        />
    );
}
